export const helpView: any = {
    contactSection: {
        title: 'Contáctanos',  
        form: {
            name: 'Nombre',
            email: 'Email',
            phoneNumber: 'Número de teléfono',
            subject: 'Asunto',
            product: 'Con relación a:',
            select: 'Selecciona',
            message: 'Cuéntanos tu situación:'
        },
        products: ['Activación Digital', 'Aplicación móvil',  'ePaper', 'Manejo de Cuenta', 'Newsletters', 'Otro', 'Pagos', 'Periódico impreso', 'Registro/Login' ]
    }, 
    faqsSection: {
        title: 'Preguntas frecuentes',
        categoriesTitle: 'Categorías'
    },
    successContactFormResponseModal: {
        title: 'Contáctanos',
        body: 'Has reportado tu situación exitosamente.'
    },
    errorContactFormResponseModal: {
        title: 'Contáctanos',
        body: 'Estamos confrontando dificultades técnicas. Queremos ayudarte, puedes comunicarte con Servicio al Cliente al 787-641-8800.'
    },
    noSearchResults: 'No encontramos resultados para tu búsqueda',
    modalActionButtons: {
        ok: 'OK',
        cancel: 'Cancelar'
    }
}    


// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/help/help.static.data.ts